export default {
      id: "unit_type_truck-usage",
      viewBox: "0 0 21 26",
      url: __webpack_public_path__ + "img/icons.svg#unit_type_truck",
      toString: function () {
        return this.url;
      }
    }